export default defineNuxtPlugin(() => {
    const device = useCookie('device')
    const { isMobile } = useCommon()
    onNuxtReady(() => {
        console.log('Nuxt.js is ready and mounted')
        // do something at startup
        device.value = isMobile.value ? 'mobile' : 'desktop'
    })
})
